import {
	provideHttpClient,
	withFetch,
	withInterceptors,
} from "@angular/common/http";
import {
	type ApplicationConfig,
	inject,
	isDevMode,
	provideAppInitializer,
	provideZonelessChangeDetection,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
	RouteReuseStrategy,
	provideRouter,
	withViewTransitions,
} from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";
import { routes } from "./app.routes";
import {
	AuthorizationInterceptor,
	ReplicacheRefreshInterceptor,
} from "./interceptors";
import { CognitoService } from "./services";
import { CustomRouteReuseStrategy } from "./utils";

export const appConfig: ApplicationConfig = {
	providers: [
		provideZonelessChangeDetection(),
		provideRouter(routes, withViewTransitions()),
		provideAnimations(),
		provideHttpClient(
			withFetch(),
			withInterceptors([
				AuthorizationInterceptor,
				ReplicacheRefreshInterceptor,
			]),
		),
		provideServiceWorker("ngsw-worker.js", {
			enabled: !isDevMode(),
			registrationStrategy: "registerWhenStable:30000",
		}),
		provideAppInitializer(() => {
			// Initialize CognitoService at bootstrap
			inject(CognitoService);
			// Return a Promise/Observable if you need to block bootstrap
		}),
		{ provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
	],
};
